export const enum StaticDataType {
  TITLE = 'title',
  APPELLATION = 'appellation',
}
